import React from 'react';
import { Typography, AppBar, Toolbar } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(() => ({
  container: {
    width: '100%',
  },
  toolbar: {
    backgroundColor: 'black',
    display: 'flex',
    flexDirection: 'column',
    padding: 25,
  },
  text: {
    textAlign: 'center',
  },
}));

const Footer = () => {
  const classes = useStyles();
  return (
    <div className={classes.container}>
      <AppBar position="relative">
        <Toolbar className={classes.toolbar}>
          <Typography className={classes.text}>
            <strong>
              Seguridad y Privacidad Garantizada SSL Secure GlobalSign. Comprar
              en Ripley.com es 100% seguro.
            </strong>
          </Typography>
          <Typography className={classes.text}>
            {' '}
            Comercial ECCSA S.A., Rut N° 83.382.700-6, domiciliada en Avenida
            Cerro Colorado 5240, Torre del Parque 1 Piso 11, comuna Las Condes,
            Santiago de Chile. Precios publicados aplican exclusivamente a
            Internet y Venta Telefónica, estos pueden llegar a ser distintos en
            tiendas.
          </Typography>
        </Toolbar>
      </AppBar>
    </div>
  );
};

export default Footer;
